import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-faceapi',
  templateUrl: './faceapi.component.html',
  styleUrls: ['../../../app.component.scss', './faceapi.component.scss']
})
export class FaceapiComponent implements OnInit {
  constructor(private router: Router) {
  }

  ngOnInit(): void {

  }

  gotoPath(path: string) {
    this.router.navigate(['/face-api/' + path]).then(() => {
      window.location.reload();
    });
  }

}
